import styled from "styled-components";
import { Colors } from "../../commons/Colors";

export const Container = styled.main`
  .inner{
    padding-top: 100px;
    padding-bottom: 150px;
  }
  .ttl_area{
    margin: 0 0 50px;
    display: flex;
    align-items: center;
    button{
      height: 40px;
      margin: 0 0 0 auto;
      padding: 0 16px;
      border-radius: 8px;
    }
  }
  .head{
    font-size: 40px;
  }

  .review_item{
    + .review_item{
      border-top: 1px solid ${Colors.gray_d8};
    }
  }

  .pagination{
    margin: 70px 0 0;
  }
`